import { createContext, useContext } from 'react'

/**
 * How the reply form is drawn:
 * - `subtle`: the field and the footer are two stacked boxes on a grey fill,
 *   each with its own border, and only the field's border shows focus.
 * - `card`: one white card holds the field and the footer, and the whole
 *   card's border shows focus.
 */
export type ReplyFormSurface = 'subtle' | 'card'

export const ReplyFormSurfaceContext = createContext<ReplyFormSurface | null>(
  null,
)

export function useReplyFormSurface(): ReplyFormSurface {
  const surface = useContext(ReplyFormSurfaceContext)
  if (surface === null) {
    throw new Error('ReplyForm parts need a ReplyForm.Root')
  }
  return surface
}
